import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-hero-v2",
  templateUrl: "./hero-v2.component.html",
  styleUrls: ["./hero-v2.component.scss"],
})
export class HeroV2Component implements OnInit {
  constructor() {}

  tryPlayInterval: any;

  ngOnInit(): void {
    window.addEventListener("load", async () => {
      let video = document.querySelector("video[muted][autoplay]");
      // @ts-ignore
      video.muted = true;

      // @ts-ignore
      video.play();

      this.tryPlayInterval = setInterval(() => {
        // @ts-ignore
        if (video?.paused) {
          // @ts-ignore
          video?.play();

          // @ts-ignore
          clearInterval(this.tryPlayInterval);
        }
      }, 1000);
    });
  }
}
